import { createFileRoute } from '@tanstack/react-router'
import { GeoPage } from '~/features/admin/geo-page'

export const Route = createFileRoute('/admin/map')({
  validateSearch: (search: Record<string, unknown>) => ({
    view: search.view === 'expanded' ? ('expanded' as const) : ('card' as const),
  }),
  component: GeoPage,
})
